<div class="w-100 mt-medium surface-back radius-big d-flex align-items-center bar">
  @for (item of config(); track item) {
    <div
      class="h-100"
      [style.background-color]="item.color"
      [style.width]="item.width + '%'"
    ></div>
  }
</div>
